import axios from 'axios'

axios.defaults.baseURL = "https://freebie-app.herokuapp.com/";

export default axios;



// WEBPACK FOOTER //
// ./src/axios.js